import { DiseaseEncyclopediaBannerModel } from '@/entities/disease-encyclopedia/model/diseaseEncyclopedia';
import { Client } from '@/types/app';
import { cn } from '@/utils/style';
import React from 'react';

const DiseaseEncyclopediaBanner = ({
  client,
  banner,
}: {
  banner: DiseaseEncyclopediaBannerModel | undefined;
  client: Client;
}) => {
  const onClick = () => {
    if (banner) {
      window.open(banner.getExternalUrl(), '_blank');
    }
  };

  if (!banner) {
    return <></>;
  }

  return (
    <div
      className={cn('mx-[24px] mb-[32px] flex items-center justify-between rounded-[16px] bg-gray-30 p-[24px]', {
        'aspect-[722/174]': !client.isMobile,
        'aspect-[312/174]': client.isMobile,
      })}
    >
      <div className={'flex flex-col'}>
        <p className={'typography-ui-17sb mb-[2px] text-gray-800'}>{banner.getTitle()}</p>
        <p className={'typography-ui-15m mb-[16px] flex-1 break-keep text-gray-500'}>{banner.getDescription()}</p>
        <button
          onClick={onClick}
          className={'typography-ui-15sb mt-auto h-[40px] w-fit rounded-[8px] bg-primary-600 px-[12px] text-white'}
        >
          {banner.getButtonPhrase()}
        </button>
      </div>
      <img
        className={cn('aspect-square', {
          'h-[100px] w-[100px]': client.isMobile,
          'h-[120px] w-[120px]': !client.isMobile,
        })}
        src={banner.getImageUrl() ?? ''}
        alt={'닥터나우 진료 이미지'}
      />
    </div>
  );
};

export default DiseaseEncyclopediaBanner;
